/* voltage: reward product cart rules
   Needs a paid item to check out, one reward per order. Front end only. */
(function () {
  "use strict";

  var cfg = window.VoltageRewardCart || {};
  if (!cfg.enabled) return;

  var TYPE = String(cfg.productType || "Reward").trim().toLowerCase();
  var ROOT = (cfg.root || (window.Shopify && Shopify.routes && Shopify.routes.root) || "/").replace(/\/$/, "");
  var MSG = {
    needPaid: cfg.needPaidText || "Add at least one paid product to your cart in order to redeem",
    oneOnly: cfg.oneOnlyText || "You can only redeem one free product per purchase",
  };
  var CHECKOUT = ".cart-summary__checkout-button";
  var QTY = 'quantity-selector-component[data-context="cart-items"]';

  var items = [];
  function isReward(item) {
    return String(item.product_type || "").trim().toLowerCase() === TYPE;
  }
  function loadCart() {
    return fetch(ROOT + "/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { items = (c && c.items) || []; return items; })
      .catch(function () { return items; });
  }

  // null, "needPaid" or "oneOnly"
  function problem() {
    var rewardUnits = 0, paidLines = 0;
    items.forEach(function (i) { if (isReward(i)) rewardUnits += i.quantity; else paidLines++; });
    if (rewardUnits > 0 && paidLines === 0) return "needPaid";
    if (rewardUnits > 1) return "oneOnly";
    return null;
  }

  function apply() {
    var p = problem();

    document.querySelectorAll(CHECKOUT).forEach(function (btn) {
      var row = btn.parentElement;
      var box = row && row.parentElement; // also holds the express buttons
      if (!box) return;
      var msg = box.querySelector(".voltage-reward-cart__message");
      if (p) {
        if (!msg) {
          msg = document.createElement("p");
          msg.className = "voltage-reward-cart__message alert alert--error alert--small";
          msg.setAttribute("role", "alert");
          box.insertBefore(msg, row);
        }
        if (msg.textContent !== MSG[p]) msg.textContent = MSG[p];
        btn.disabled = true;
        btn.setAttribute("aria-disabled", "true");
        btn.classList.add("voltage-reward-locked");
      } else {
        if (msg) msg.remove();
        if (btn.classList.contains("voltage-reward-locked")) {
          btn.classList.remove("voltage-reward-locked");
          btn.removeAttribute("aria-disabled");
          btn.disabled = items.length === 0; // theme default
        }
      }
      var express = box.querySelector(".additional-checkout-buttons");
      if (express) express.classList.toggle("voltage-reward-hidden", !!p);
    });

    // cap reward lines at 1; readonly, not disabled, so the input still submits
    document.querySelectorAll(QTY).forEach(function (sel) {
      var input = sel.querySelector("[data-cart-line]");
      var line = input ? parseInt(input.getAttribute("data-cart-line"), 10) : 0;
      var item = line ? items[line - 1] : null;
      var lock = !!(item && isReward(item));
      var was = sel.classList.contains("voltage-reward-line");
      if (!lock && !was) return;
      sel.classList.toggle("voltage-reward-line", lock);
      var plus = sel.querySelector(".quantity-plus");
      var minus = sel.querySelector(".quantity-minus");
      if (input) {
        if (lock) { input.setAttribute("max", "1"); input.setAttribute("data-voltage-max", "1"); }
        else if (input.getAttribute("data-voltage-max")) { input.removeAttribute("max"); input.removeAttribute("data-voltage-max"); }
        input.readOnly = lock;
        input.disabled = false;
      }
      if (plus) plus.disabled = lock;
      if (minus) minus.disabled = false;
      if (lock && item.quantity > 1 && input) heal(item, input, line);
    });
  }

  // reset a reward line above 1 via the theme's quantity event; throttled per line
  var healed = {};
  function heal(item, input, line) {
    var now = Date.now();
    if (healed[item.key] && now - healed[item.key] < 5000) return;
    healed[item.key] = now;
    input.value = "1";
    input.dispatchEvent(new CustomEvent("quantity-selector:update", { bubbles: true, detail: { quantity: 1, cartLine: line } }));
  }

  // block edits on locked inputs; Tab and Escape still work
  function lockedInput(e) {
    var t = e.target;
    return t && t.classList && t.classList.contains("quantity-input") && t.closest && t.closest(".voltage-reward-line") ? t : null;
  }
  ["keydown", "beforeinput", "paste", "drop", "wheel"].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (!lockedInput(e)) return;
      if (type === "keydown" && (e.key === "Tab" || e.key === "Escape")) return;
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);
  });
  // revert programmatic value changes before the theme sees them
  ["input", "change"].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var input = lockedInput(e);
      if (!input) return;
      var line = parseInt(input.getAttribute("data-cart-line"), 10);
      var item = line ? items[line - 1] : null;
      var real = item ? String(Math.min(item.quantity, 1)) : "1";
      if (input.value !== real) input.value = real;
    }, true);
  });

  // in case something re-enables the locked buttons
  document.addEventListener("click", function (e) {
    var t = e.target && e.target.closest && e.target.closest(CHECKOUT + ".voltage-reward-locked, .voltage-reward-line .quantity-plus");
    if (t) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  var timer = null;
  function refresh(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () { loadCart().then(apply); }, delay || 0);
  }

  // cart:updated fires after re-render; cart:update fires before the drawer morphs
  document.addEventListener("cart:updated", function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (cart && cart.items) { items = cart.items; apply(); } else refresh();
  });
  document.addEventListener("cart:update", function () { refresh(400); });
  document.addEventListener("shopify:section:load", function () { refresh(); });

  // re-apply when cart lines re-render
  var scheduled = false;
  new MutationObserver(function (records) {
    if (scheduled) return;
    for (var i = 0; i < records.length; i++) {
      var target = records[i].target;
      if (target && target.closest && target.closest("cart-drawer-component, cart-items-component, .cart-items, .cart-summary")) {
        scheduled = true;
        requestAnimationFrame(function () { scheduled = false; apply(); });
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // skip the fetch when the cart is empty
  var bubble = document.querySelector("cart-count");
  var onCartPage = location.pathname.indexOf(ROOT + "/cart") === 0 || location.pathname.indexOf("/cart") === 0;
  if (onCartPage || (bubble && !bubble.classList.contains("hidden"))) refresh();
})();
